import React, {useEffect, useContext, useState} from 'react';
import _ from 'lodash';
import {Grid, Container} from '@material-ui/core';

import FilmCartouche from 'components/Film/FilmCartouche';
import MySwiper from 'components/Shared/MySwiper';
import Context from 'utils/Context';

import CinemaCard from '../CinemaCard';
import './CinemaSlider.scss';

const CinemaSlider = ({cinemas, films}) => {
  const [visibleLinesNb, setVisibleLinesNb] = useState(3);
  const {modele, methods, goTo, appState} = useContext(Context);

  const containerRef = React.createRef();

  useEffect(() => {
    const handleScroll = e => {
      const areSomeCinemasHidden = visibleLinesNb < cinemas.length;
      if (areSomeCinemasHidden && containerRef.current.getBoundingClientRect().bottom <= window.innerHeight) {
        setVisibleLinesNb(old => old + 1);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [cinemas.length, containerRef, visibleLinesNb]);

  const renderCinema = cinema => {
    const cinema_id = cinema.cinema_id;
    let seances = _.groupBy(_.filter(modele.seances, {cinema_id, local: true}), 'film_id');
    let nb = 5;
    if (appState.screenSize === 'xs') nb = 3;
    if (appState.screenSize === 'sm') nb = 3;
    if (appState.screenSize === 'md') nb = 4;
    if (appState.screenSize === 'xl') nb = 6;
    let ratio = 1;
    if (appState.screenSize === 'xs') ratio = 2.5;
    const sliderParams = {
      speed: 800,
      spaceBetween: 30,
      slidesPerView: nb,
      slidesPerGroup: nb,
      navigation: true,
      longSwipesRatio: 0.2,
      on: {init: methods.tick},
    };
    const list = Object.keys(seances).map(film_id => {
      const film = _.find(films, {film_id: parseInt(film_id)});
      if (!film) return null;
      return (
        <FilmCartouche film={film} onClick={() => goTo('/cinema/' + cinema_id + '/' + film_id)} appState={appState} />
      );
    });
    if (!list.length) {
      return null;
    }
    return (
      <Grid container justifyContent="center" key={'cinema-' + cinema_id} className="cinema-slider__infos">
        <Grid item xs={12} sm={4} md={3}>
          <Grid container>
            <Grid item xs={12} sm={11} className="cinema-slider__infos-left">
              <CinemaCard cinema={cinema} goTo={goTo} ratio={ratio} />
              <div className="spacer" />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={8} md={9} className="cinema-slider__infos-right">
          <Container maxWidth="xl">
            <MySwiper list={list} params={sliderParams} />
          </Container>
        </Grid>
      </Grid>
    );
  };

  const visibleCinemas = cinemas.slice(0, visibleLinesNb);

  if (!cinemas) {
    return null;
  }
  return <div ref={containerRef}>{visibleCinemas.map(renderCinema)}</div>;
};

export default CinemaSlider;
